"use strict";import{hasStyle as s,createStyle as t}from"./ManagedStyles.js";import a from"./generated/css/SystemCSSVars.css.js";const e=()=>{s("data-ui5-system-css-vars")||t(a,"data-ui5-system-css-vars")};export default e;
//# sourceMappingURL=SystemCSSVars.js.map
